var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /photo-order/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f20eb234","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/photo-order/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/AuthPage.vue
// module id = null
// module chunks = 